(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["clik-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('clik-product-description')) {
    customElements.define('clik-product-description', class extends HTMLElement {
      connectedCallback() {
        this.description ||= this.querySelector('.product-form__description');
        if (!this.description) return;

        this.mediaQuery = window.matchMedia('(min-width: 1000px)');
        this.onLayoutChange = () => this.placeDescription();
        this.mediaQuery.addEventListener('change', this.onLayoutChange);
        document.addEventListener('shopify:section:load', this.onLayoutChange);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.onLayoutChange, { once: true });
        }
        this.placeDescription();
      }

      disconnectedCallback() {
        this.mediaQuery?.removeEventListener('change', this.onLayoutChange);
        document.removeEventListener('shopify:section:load', this.onLayoutChange);
        document.removeEventListener('DOMContentLoaded', this.onLayoutChange);
        if (this.description && !this.contains(this.description)) this.description.remove();
        this.contentSection?.classList.remove('clik-product-content--columns');
      }

      placeDescription() {
        this.contentSection?.classList.remove('clik-product-content--columns');
        if (!this.mediaQuery.matches) {
          this.append(this.description);
          return;
        }

        this.contentSection = document.querySelector(
          `.product-content[data-clik-product-id="${this.dataset.productId}"]`
        );
        const destination = this.contentSection || document.getElementById(this.dataset.target);
        if (!destination) return;

        if (this.contentSection) {
          this.contentSection.prepend(this.description);
          this.contentSection.classList.add('clik-product-content--columns');
        } else {
          destination.replaceChildren(this.description);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
